export default __webpack_public_path__ + "images/assets/7e31296c6e16547ce55826205a2a4d51.svg";